import { Modelo } from '@ext/index';
import * as Types from './Factura.types';
import moment, { Moment } from 'moment';

export class IFactura extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Empresa: string = '';
    public Linea: string = '';
    public Fecha: Moment = moment( '' );
    public PuntoDeVenta: number = 0;
    public Numero: number = 0;
    public Letra: string = '';
    public TipoMovimiento: number = 0;
    public Cliente: number = 0;
    public Cuit: string = '';
    public CAE: string = '';
    public ImporteFinal: number = 0;
    public ImporteNeto: number = 0;
    public DescuentoNeto: number = 0;
    public Retenciones: number = 0;
    public Iva: number = 0;
    public IvaExento: number = 0;
    public Observacion: string = '';
    public NotaDeCredito: string = '';
    public CodigoProvincia: string = '';
    public Vencimiento: Moment = moment( '' );
    public FechaExpiracion: Moment = moment( '' );
    public CondicionDePago: string = '';
    public Vendedor: string = '';
    public Despachante: string = '';

    public get esNotaDeCredito(): boolean
    {
        return [5].includes( this.TipoMovimiento );
    }

    public get esFactura(): boolean
    {
        return [1].includes( this.TipoMovimiento );
    }

    public get esLiquidacion(): boolean
    {
        return [60].includes( this.TipoMovimiento );
    }

    public getJson(): any
    {
        let json: any = {};

        json.empresa = this.Empresa;
        json.linea = this.Linea;
        json.fecha = this.Fecha.toSQL();
        json.punto_de_venta = this.PuntoDeVenta;
        json.numero = this.Numero;
        json.letra = this.Letra;
        json.tipo_movimiento = this.TipoMovimiento;
        json.cliente = this.Cliente;
        json.cuit = this.Cuit;
        json.cae = this.CAE;
        json.importe_final = this.ImporteFinal;
        json.importe_neto = this.ImporteNeto;
        json.descuento_neto = this.DescuentoNeto;
        json.retenciones = this.Retenciones;
        json.iva = this.Iva;
        json.iva_exento = this.IvaExento;
        json.observacion = this.Observacion;
        json.nota_de_credito = this.NotaDeCredito;
        json.codigo_provincia = this.CodigoProvincia;
        json.vencimiento = this.Vencimiento.toSQL();
        json.fecha_expiracion = this.FechaExpiracion.toSQL();
        json.condicion_de_pago = this.CondicionDePago;
        json.vendedor = this.Vendedor;
        json.despachante = this.Despachante;


        return json;
    }


    public set(): boolean
    {

        this.Empresa = !this.Json.empresa ? '' : this.Json.empresa;
        this.Linea = !this.Json.linea ? '' : this.Json.linea;
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.PuntoDeVenta = !this.Json.punto_de_venta ? 0 : this.Json.punto_de_venta;
        this.Numero = !this.Json.numero ? 0 : this.Json.numero;
        this.Letra = !this.Json.letra ? '' : this.Json.letra;
        this.TipoMovimiento = !this.Json.tipo_movimiento ? 0 : this.Json.tipo_movimiento;
        this.Cliente = !this.Json.cliente ? 0 : this.Json.cliente;
        this.Cuit = !this.Json.cuit ? '' : this.Json.cuit;
        this.CAE = !this.Json.cae ? '' : this.Json.cae;
        this.ImporteFinal = !this.Json.importe_final ? 0 : this.Json.importe_final;
        this.ImporteNeto = !this.Json.importe_neto ? 0 : this.Json.importe_neto;
        this.DescuentoNeto = !this.Json.descuento_neto ? 0 : this.Json.descuento_neto;
        this.Retenciones = !this.Json.retenciones ? 0 : this.Json.retenciones;
        this.Iva = !this.Json.iva ? 0 : this.Json.iva;
        this.IvaExento = !this.Json.iva_exento ? 0 : this.Json.iva_exento;
        this.Observacion = !this.Json.observacion ? '' : this.Json.observacion;
        this.NotaDeCredito = !this.Json.nota_de_credito ? '' : this.Json.nota_de_credito;
        this.CodigoProvincia = !this.Json.codigo_provincia ? '' : this.Json.codigo_provincia;
        this.Vencimiento = !this.Json.vencimiento ? moment( '' ) : moment( this.Json.vencimiento );
        this.FechaExpiracion = !this.Json.fecha_expiracion ? moment( '' ) : moment( this.Json.fecha_expiracion );
        this.CondicionDePago = !this.Json.condicion_de_pago ? '' : this.Json.condicion_de_pago;
        this.Vendedor = !this.Json.vendedor ? '' : this.Json.vendedor;
        this.Despachante = !this.Json.despachante ? '' : this.Json.despachante;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IFactura )
    {
        this.Model = Model;
    }

    public Model: IFactura;
}